import { IRouterContext } from '../Components/Router/Interfaces/IRouterContext.interface';

export const strictOnDomain = (
	listOfLangs: Array<String>,
	routerContext: IRouterContext
) => listOfLangs.includes(routerContext.lang.value.id);
